import { useEffect } from "react";
const BASE = "MSK Care";
export function useDocumentTitle(pageTitle: string) {
  useEffect(() => {
    document.title = `${pageTitle} | ${BASE}`;
  }, [pageTitle]);
}
